import NidApp from "./api.js";

;( function( $, nordsjo, NidApp ) {

	$( window ).on( 'load', function() {

		var $vcFlex     = $( '.vc-flexslider' ),
			$vcCarousel = $( '.vc-flexslider-carousel' ),
			animation;

		if ( $vcFlex.length ) {

			animation = $vcFlex.data( 'flex_fx' );

			$vcFlex.flexslider({
				controlNav  : 'thumbnails',
				directionNav: false,
				animation   : animation,
				prevText    : '',
				nextText    : ''
			});


			$( 'a', $vcFlex ).magnificPopup({
				type: 'image',
				gallery: {
					enabled: true
				}
			});

		}

		if ( $vcCarousel.length ) {

			animation = $vcCarousel.data( 'flex_fx' );

			$vcCarousel.flexslider({
				animation: animation,
				prevText : '',
				nextText : ''
			});

		}

	});

	$( function() {

		$.extend( true, $.magnificPopup.defaults, {
			tClose: nordsjo.tClose,
			tLoading: nordsjo.tLoading,
			gallery: {
				tPrev: nordsjo.tPrev,
				tNext: nordsjo.tNext,
				tCounter: nordsjo.tCounter
			},
			image: {
				tError: nordsjo.tError
			},
			ajax: {
				tError: nordsjo.tError
			}
		});

		var $productThumbs = $( '.nordsjo-gallery-thumbs' );

		/**
		 * Get a an array of images for the lightbox.
		 *
		 * @param {int} startIndex The index at which to start the array.
		 *                         Eg. If we click the 2nd images, start with this one.
		 *
		 * @return array Array of objects.
		 */
		function getFullSizeImages( $li, startIndex ) {
			var images = [],
				prevImgs;

			$.each( $li, function() {
				var src = $( this ).find( 'a' ).data( 'full-size' );

				images.push({ src: src });
			});

			prevImgs = images.splice( startIndex, images.length );

			return prevImgs.concat( images );
		}


		$( 'a.mag-popup' ).magnificPopup({
			mainClass: 'mfp-fade',
			type     : 'image',
			titleSrc : 'title'
		});

		$( 'a.mag-popup-moodboard' ).magnificPopup({
			mainClass: 'mfp-fade',
			type     : 'image',
			titleSrc : '',
			gallery  : {
				enabled: true
			},
			callbacks: {
				open: function() {
					$( '.mfp-wrap' ).removeAttr( 'tabindex' );
				},
				change: function() {
					var url   = $( this.content ).find( 'img.mfp-img' ).attr( 'src' ),
						$link = $( '.bb-moodboard-link', $( this.content ) );

					if ( $link.length ) {
						$link.attr( 'data-url', url );
					} else {
						$( '<a class="bb-moodboard-link has-popup has-popup-below" data-url="' + url + '" href="#" data-type="image"><span>' + nordsjo.addToMoodboard + '</span></a>' ).appendTo( $( $( this.content ), '.mfp-figure' ) ).on( 'click', NidApp.addItemToMoodboard );

					}

					$( '.moodboard-modal' ).modal( 'hide' );
				}
			}
		});


		if ( $productThumbs.length ) {

			$( $productThumbs ).on( 'click', 'a', function( e ) {
				e.preventDefault();

				var $this           = $( this ),
					$parent         = $( this ).closest( '.wpb_wrapper' ),
					$productGallery = $( '.large-image-container', $parent ),
					fullSizeImg     = $this.data( 'full-size' ),
					gallHeight      = $( 'img', $productGallery ).height(),
					startIndex      = $this.data( 'index' ),
					$img, $a, $span;

				if ( $this.hasClass( 'active' ) ) {
					return;
				}

				$( 'a.vc-gallery-link', $parent ).removeClass( 'active' );
				$this.addClass( 'active' );

				$img = $( '<img />', {
					src: $this.attr( 'href' )
				});

				$a = $( '<a />', {
					href: fullSizeImg,
					'class': 'prod-medium-image loading'
				});

				$span = $( '<span />', {
					'class': 'hover-overlay'
				});

				$a.append( $img ).append( $span ).hide().magnificPopup({
					items: getFullSizeImages( $( 'li', $parent ), startIndex ),
					gallery: {
						enabled: true
					},
					mainClass: 'mfp-fade',
					type: 'image'
				});

				$productGallery.append( $a ).addClass( 'loading' );

				$img.on( 'load', function() {
					$productGallery.add( $( '.prod-medium-image' ) ).removeClass( 'loading' );

					var $prodImages = $( 'a.prod-medium-image', $productGallery );
					if ( $prodImages.length > 1 ) {
						$productGallery.removeClass( 'loading' ).find( 'a.prod-medium-image' ).eq( 0 ).remove();
						$prodImages.eq( 1 ).fadeIn();
					} else {
						$prodImages.eq( 0 ).fadeIn();
					}
				});

			}).find( 'a:first' ).trigger( 'click' );

		}


		$( '.social-links' ).on( 'click', 'a.popup', function( e ) {

			var winWidth  = $( window ).width(),
				winHeight = $( window ).height(),
				width     = 500,
				height    = 250;


			if ( winWidth < width ) {
				width = winWidth - 20;
			}

			if ( winHeight < height ) {
				height = winHeight - 10;
			}

			var params = 'width=' + width + ',height=' + height + ',location=0,menubar=0,toolbar=0,status=0,resizable=1';
			var popup  = window.open( this.href, 'social', params );

			if ( popup ) {
				popup.focus();
				e.preventDefault();
			}

		});

		$( 'a.print' ).on( 'click', function( e ) {
			e.preventDefault();

			window.print();
		});


		/**
		 * Get the number of items in the wishlist.
		 *
		 * This will use a (fast) AJAX call to get the cookie if the user
		 * is not logged in. Otherwise it'll grab the number from the
		 * nordsjo object.
		 */
		function showNumItemInWishlist() {
			if ( 'ajax' === nordsjo.numItemsInWishlist ) {
				$.post( nordsjo.shortinitAjaxUrl + 'wishlist-count.php', { action: 'get_wishlist' } ).done( function( result ) {
					updateWishlistCount( result );
				});
			} else {
				updateWishlistCount( nordsjo.numItemsInWishlist );
			}
		}
		showNumItemInWishlist();


		/**
		 * Show a counter for the number of items in the wishlist.
		 *
		 * @param {int} num Number of items in the wishlist.
		 */
		function updateWishlistCount( num ) {
			var $counter = $( '<span />', {
				'class': 'wishlist-counter',
				id     : 'wishlist-counter',
				text   : num
			});

			$( '.user-links .wishlist' ).append( $counter );
		}


		/** Return the highest column value in the grid and return one number higher than this. */
		function getHighestRow( grid ) {
			if ( 0 === grid.length ) {
				return 1;
			}

			var lastWidget = grid[ grid.length - 1 ];

			return lastWidget.row + lastWidget.sizey;
		}


		$( '.modal-d-container' )
			.on( 'click', '.add-to-mb-btn a', function( e ) {
				e.preventDefault();

				var $this  = $( e.currentTarget ),
					$modal = $this.closest( '.moodboard-modal' ),
					grid   = [];

				if ( ! $modal.length ) {
					$modal = $this.closest( '.ii-modal' );
				}

				if ( ! $modal.length ) return;

				if ( $this.hasClass( 'cookie-moodboard' ) ) {

					// No localStorage === no moodboard. Sorry bro.
					if ( false === NidApp.checkIfLocalStorageAvailable() ) {
						alert( nordsjo.localStorageNotAvailable );
						return;
					}

					var moodboardCookie = localStorage.getItem( 'moodboardCookie' );
					if ( moodboardCookie ) {
						grid = JSON.parse( moodboardCookie );
					}

				} else {
					grid = JSON.parse( $this.attr( 'data-content' ) );

				}

				var data = {
						moodboard_id: $this.data( 'id' ),
						type        : $modal.data( 'type' ),
						security    : nordsjo.ajaxNonce,
						grid        : grid,
						action      : 'add_item_to_moodboard',
						widget      : {
							col            : 1,
							row            : 1,
							sizex          : 2,
							sizey          : 1,
							backgroundColor: '',
							backgroundImage: '',
							imageId        : '',
							text           : ''
						}
					};


				// The data.type should provide a hook for other types if required.
				// See also NidApp.addItemToMoodboad();

				if ( 'image' === data.type ) {
					// data.image_id = $modal.data( 'image-id' );
					data.widget.backgroundImage = $modal.data( 'image-url' );
					data.widget.imageId         = $modal.data( 'image-id' );
				} else {
					data.widget.backgroundColor = $modal.data( 'rgb' );
					data.widget.text            = $modal.data( 'text' );
				}

				if ( $.isArray( data.grid ) && data.grid.length > 0 ) {
					data.widget.row = getHighestRow( data.grid );
				} else {
					// Sometimes the JSON gets out of whack for empty grids,
					// so we can add a wee fix here if required.
					data.grid = [];
				}

				data.grid.push( data.widget );
				data.grid = JSON.stringify( data.grid );

				if ( $( 'body' ).hasClass( 'logged-in' ) ) {

					// For signed in users, create the board.
					$.when( NidApp.doAjaxCall( data ) ).done( function( result ) {
						if ( true === result.success ) {
							$this.find( '.check' ).css({ opacity: 1 });
							$this.attr( 'data-content', data.grid );

							// Rebuild the global object.
							NidApp.$moodboards = $this.closest( 'ul.moodboard-selector' ).find( 'li.add-to-mb-btn' );
						}

					});

				} else {
					// Otherwise save the board in a JS cookie.
					$this.find( '.check' ).css({ opacity: 1 });

					// console.log( 'Local Storage previous value: ', localStorage.getItem( 'moodboardCookie' ) );
					localStorage.setItem( 'moodboardCookie', data.grid );
					// console.log( 'Local Storage now updated to: ', localStorage.getItem( 'moodboardCookie' ) );
				}

			})
			.on( 'click', 'a.add-new-moodboard', function( e ) {
				e.preventDefault();

				$( this ).closest( '.modal-content' ).find( '.new-modal-mb' ).toggleClass( 'hide' );
			})
			.on( 'submit', 'form.new-mb-form', function( e ) {
				e.preventDefault();

				var $this = $( this ),
					data = {
						title   : $( '.mb-title', $this ).val(),
						excerpt : $( '.mb-subtitle', $this ).val(),
						security: nordsjo.ajaxNonce,
						action  : 'nid_new_moodboard'
					};

				if ( '' === data.title ) {
					NidApp.showMessage( nordsjo.pleaseEnterMoodboardTitle, 'error' );
					return;
				}

				$.when( NidApp.doAjaxCall( data ) ).done( function( result ) {
					if ( true === result.success ) {
						$( '.new-modal-mb input', $this ).val( '' );

						var $modal   = $this.closest( '.modal-content' ),
							$firstLi = $( 'li.add-to-mb-btn', $modal ).eq( 0 ),
							$newLi   = $firstLi.clone(),
							title    = data.title;

						if ( '' !== data.excerpt ) {
							title = data.title + ' - ' + data.excerpt;
						}

						$newLi
							.find( '.text' )
								.text( title )
								.end()
							.find( 'a' )
								.attr( 'data-id', result.data.moodboard_id )
								.attr( 'data-content', '[]' )
								.end()
							.hide()
							.prependTo( $( '.moodboard-selector' ) )
							.fadeIn( 200 );

						if ( $newLi.hasClass( 'hidden' ) ) {
							$newLi.removeClass( 'hidden' );
						}

						$( '.new-modal-mb', $modal ).toggleClass( 'hide' );
						$( '.mb-title', $this ).val( '' );
						$( '.mb-subtitle', $this ).val( '' );
					}

				});
			});


		$( 'body' ).on( 'click', '.ii-show-hide', function( e ) {
			e.preventDefault();

			var $this = $( this );
			if ( $this.hasClass( 'visible' ) ) {
				$this
					.removeClass( 'visible' )
					.find( 'span' ).text( nordsjo.showProducts ).end()
					.closest( 'div' ).find( 'a.product-trigger' ).removeClass( 'visible' ).end()
					.closest( 'div' ).find( 'a.ii-product-trigger' ).removeClass( 'visible' );

			} else {
				$this
					.addClass( 'visible' )
					.find( 'span' ).text( nordsjo.hideProducts ).end()
					.closest( 'div' ).find( 'a.product-trigger' ).addClass( 'visible' ).end()
					.closest( 'div' ).find( 'a.ii-product-trigger' ).addClass( 'visible' );

			}

		});


		// Show product information when you click on a link
		$( 'body' ).on( 'click', 'a.product-trigger', function( e ) {
			e.preventDefault();

			var $this      = $( this ),
				product_id = $this.data( 'product-id' ),
				color_id   = $this.data( 'color-id' ),
				$modal     = $( '#product-' + product_id ),
				product;

			if ( $this.hasClass( 'loading' ) ) {
				return;
			}

			if ( $modal.length ) {
				$modal.modal({ keyboard: true });
				return;

			} else {

				NidApp.showLoadingIcon();
				product = NidApp.renderProductPopupInformation( product_id, color_id );
				$this.addClass( 'loading' );

				$.when( product ).done( function( result ) {
					NidApp.removeLoadingIcon();
					if ( true === result.success ) {
						$( '.modal-d-container' ).append( result.data );
						$this.removeClass( 'loading' );

						$( '#product-' + product_id )
							.modal()
							.on('click', 'a.wishlist-button', NidApp.addProductToCart );
							// .on( 'click', 'a.moodboard-button', showMoodboardList );

					} else {
						NidApp.showMessage( result.data.message, 'error' );

					}

				});
			}

		});


		function showMoodboardList( e ) {
			e.preventDefault();

			var $this   = $( e.currentTarget ),
				data    = $this.data(),
				$modal  = $this.closest( '.moodboard-modal' ),
				$list   = $( '.moodboard-selector', $modal ),
				$toggle = $( '.new-modal-mb', $modal ),
				$mbCont = $( '.moodboards-inspiration-list', $modal ),
				moodboards,
				imageUrl;

			if ( $list.hasClass( 'has-boards' ) ) {
				$mbCont.removeClass( 'hide' );
				return;
			}

			if ( null === NidApp.$moodboards ) {

				moodboards = NidApp.jqueryPost({ action: 'ajax_get_moodboards' });
				imageUrl   = NidApp.jqueryPost({ image_id: data.imageId, action: 'nid_get_image_url' });

				$.when( moodboards, imageUrl ).done( function( result, imageUrl ) {
					NidApp.removeLoadingIcon();

					if ( true === result.success ) {

						NidApp.$moodboards = $( result.data );

						$toggle.addClass( 'hide' );
						$mbCont.removeClass( 'hide' );
						$modal
							.data( 'id', data.id )
							.data( 'type', data.type )
							.data( 'image-url', imageUrl.data )
							.find( '.add-to-mb-btn' )
								.remove()
								.end();

						$( 'li.add-to-mb-btn', $list ).remove();
						$list.prepend( NidApp.$moodboards );
						$( 'span.check' ).css({ opacity: '0' });

						if ( 'image' === data.type ) {
							$modal.data( 'image-id', data.imageId );
						}

					} else {
						NidApp.showMessage( result.data.message, 'error' );

					}

				});

			} else {
				imageUrl = NidApp.jqueryPost({ image_id: data.imageId, action: 'nid_get_image_url' });

				$.when( imageUrl ).done( function( imageUrl ) {
					NidApp.removeLoadingIcon();

					if ( true === result.success ) {

						$toggle.addClass( 'hide' );
						$mbCont.removeClass( 'hide' );
						$modal
							.data( 'id', data.id )
							.data( 'type', data.type )
							.data( 'image-url', imageUrl.data )
							.find( '.add-to-mb-btn' )
								.remove()
								.end();

						$( 'li.add-to-mb-btn', $list ).remove();
						$list.prepend( NidApp.$moodboards );
						$( 'span.check' ).css({ opacity: '0' });

						if ( 'image' === data.type ) {
							$modal.data( 'image-id', data.imageId );
						}

					} else {
						NidApp.showMessage( result.data.message, 'error' );

					}

				});


			}
		}


        /** Toggle the list of options when the trigger is clicked */
        $( '.options-header' ).on( 'click', function( e ) {
            e.preventDefault();

            $( this ).toggleClass( 'open' ).next().toggle( 300 );
        });


		/** Popup boxes prevent to go of screen/flexslider on mouseover */
		// Product-list
		$( document ).on( 'mouseenter', '.has-popup-below', function () {
			var $popupBox = $( this ).children( 'span' );
			if ( ! $popupBox.length ) return;

			var $check = $popupBox.offset().left + 200;
			if ( $check > $( window ).width() ) {
				$popupBox.css( 'left', '-170px' );
			}

		});
		// Flexslider viewport
		$( document ).on({
			mouseenter: function(){

				var $popupBox = $( this ).children( 'span' );
				if ( ! $popupBox.length ) return;

				var $check = $popupBox.offset().left + 200;
				if ( $check > $( '.flex-viewport' ).width() ) {
					$popupBox.css( 'left', '-170px' );
				} else {
					return;
				}

			},
			mouseleave: function(){

				var $popupBox = $( this ).children( 'span' );
				if ( $popupBox.css( 'left', '-170px' ) ) {
					$popupBox.hide().css( 'left', '-90px' );
				}

			}
		}, '.flex-viewport ul li .has-popup-below');


		$( document.getElementById( 'footer-navigation' ) ).on( 'click', 'a.parent-a', function( e ) {
			var text = $( this ).find( 'span' ).text();
			if (  'Våra butiker' === text || 'Våre butikker' === text ) {
				e.preventDefault();

				$( '.header-main' ).addClass( 'nav-down' );
				$( document.getElementById( 'show-store-trigger' ) ).trigger( 'click' );
			}

		});

	});

	var $campaignForm = $( '#sms-campaign-form' ),
		$gRecaptcha = $( '#g-recaptcha' );

	function nidSubmitCampaignForm() {
		var data = {
			action: 'parse_sms_campaign_form',
			nid_fast_ajax: 1,
			campaign: {
				firstname: $('#sms-campaign-form--firstname').val(),
				lastname: $('#sms-campaign-form--lastname').val(),
				email: $('#sms-campaign-form--email').val(),
				telephone: $('#sms-campaign-form--telephone').val(),
				store: $('#sms-campaign-form--store').val(),
				mailinglist: ( $('#sms-campaign-form--mailpoet').is(':checked') ) ? '1' : '0',
				campaign_url: nordsjo.campaignUrl,
				sms: {
					sender: nordsjo.smsSender,
					message: nordsjo.smsMessage,
					thank_you_message: nordsjo.smsThankYou
				},
				reCaptcha: grecaptcha.getResponse()
			}
		};

		// console.log( data );
		var result = NidApp.doAjaxCall( data );
		$.when( result ).done( function( result ) {
			// console.log( result );
			if ( true === result.success ) {
				$campaignForm.addClass( 'submitted' ).find( 'input' ).val( '' );
				$( 'button', $campaignForm ).attr( 'disabled', true );

				$( '#sms-campaign-message' ).addClass( 'has-message' ).text( nordsjo.smsThankYou );
			}
		});
	}

	$campaignForm.on( 'submit', function( e ) {
		var errors = false;

		e.preventDefault();

		$.each( $( '.sms-campaign-form--required', this ), function() {
			var $this = $( this );
			$this.parent().removeClass( 'error' );

			if ( '' === $this.val() ) {
				$this.parent().addClass( 'error' );
				errors = true;
			}
		});

		$gRecaptcha.removeClass( 'error' );
		if ( '' === grecaptcha.getResponse() ) {
			errors = true;
			$gRecaptcha.addClass( 'error' );
		}

		if ( true === errors ) {
			NidApp.showMessage( nordsjo.pleaseFillInRequiredFields, 'error' );
		}
		else {
			nidSubmitCampaignForm();
		}
	});
	
}( jQuery, nordsjo, NidApp ));
